<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.jushuitanOrder')"
    resource="jushuitan_orders"
    index-exec-filter-router-type="push"
    :batch-actions="hasBatchActions ? batchActions : null"
  >
  <template slot="action">
      <bean-import-button
        can='jushuitan_orders.import_freight'
        buttonText="导入运费"
        tooltipText="下载运费模板"
        url="/jushuitan_orders/import_freight"
        :loadingToast="$t('importLoadingToast')"
        :fileChangeHandler="handleImportFreightFileChange"
      >
        <template slot="download">
          <el-popover trigger="hover">
            <div style="cursor: pointer;" @click="downloadFreightTpl">下载运费模板</div>
            <i class="el-icon-info btn-tip-trigger" slot="reference" @click.stop></i>
          </el-popover>
        </template>
      </bean-import-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/jushuitan_orders.js';
import { filterColumnsExtend as customerFilterColumnsExtend } from '../admin_grapes/customers.js';
// import { formColumnsExtend as paymentAllocationFormCloumnsExtend } from '../admin_entities/payment_allocation_detail.js';
// import { formColumnsExtend as adjustmentFormCloumnsExtend } from '../admin_grapes/adjustments.js';
import { OrderStatus } from '@/constants';
import _ from 'lodash';
import { displayText } from '@/custom_models_extend';
import Utils from '../components/utils.vue';
import { abilityService } from 'beans-admin-plugin';

@Component
export default class JushuitanOrders extends Mixins(Vue, Utils) {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      { prop: 'keyword', label: this.$t('keyword'), renderCell: 'input' },
      'o_id_eq',
      {
        key: 'status_in',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            options: _.map(OrderStatus, (key, value) => ({ label: key, value }))
          }
        }
      },
      'shop_id_eq',
      {
        key: 'created_gteq_date',
        label: `${this.$t('jushuitanOrder.created')}${this.$t('gteqDatetime')}`,
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          }
        }
      },
      {
        key: 'created_lteq_date',
        label: `${this.$t('jushuitanOrder.created')}${this.$t('lteqDatetime')}`,
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          }
        }
      },
      {
        key: 'sent_at_gteq_date',
        label: `${this.$t('jushuitanOrder.sentAt')}${this.$t('gteqDatetime')}`,
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          }
        }
      },
      {
        key: 'sent_at_lteq_date',
        label: `${this.$t('jushuitanOrder.sentAt')}${this.$t('lteqDatetime')}`,
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          }
        }
      },
      {
        key: 'customer_id_not_null',
        label: '是否关联客户',
      },
      'customer_id_eq',
      {
        key: 'user_id_not_null',
        label: '是否关联业务员',
      },
      abilityService.can('users.read_options') && 'user_id_eq',
      {
        key: 'customer_customer_source_id_eq',
        prop: 'customer_customer_source_id_in',
        renderCell: {
          props: {
            multiple: true,
          }
        }
      },
      'customer_customer_level_id_eq',
      'customer_customer_tags_id_eq',
      {
        ...customerFilterColumnsExtend(['customer_business_models_id_eq'])[0],
        prop: 'customer_customer_business_models_id_eq',
      },
      {
        prop: 'related',
        label: '是否相关',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { value: true, label: this.$t('bean.yes') },
              { value: false, label: this.$t('bean.no') }
            ]
          }
        }
      },
      {
        prop: 'l_id_eq',
        label: this.$t('jushuitanOrder.lId'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'sent_without_fully_paid',
        label: '已发货未付全款',
        renderCell: {
          component: 'switch',
        }
      },
      {
        prop: 'has_sales_orders',
        label: '是否已关联销售订单',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { value: '1', label: '已关联' },
              { value: '0', label: '未关联' }
            ]
          }
        }
      },
      {
        prop: 'customer_taggings_tag_id_eq',
        label: '客户系统标签',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/acts_as_taggable_on/tags/read_options', {
                keyword: '新客',
                per_page: 1000
              })
              return data.map(tag => ({ value: tag.id, label: tag.name }))
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/acts_as_taggable_on/tags/read_options', {
                keyword: keyword || '新客',
                per_page: 1000
              })
              return data.map(tag => ({ value: tag.id, label: tag.name }))
            }
          }
        }
      }
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'o_id',
      'so_id',
      {
        key: 'status',
        renderCell(h, { props: { value } }) {
          return <span>{OrderStatus[value]}</span>
        }
      },
      {
        key: 'customer',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'customers.show', params: { id: value.id } }}>{displayText(value)}</bean-link>
          } else {
            return <span>/</span>
          }
        },
      },
      {
        key: 'shop',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'jushuitan_shops.show', params: { id: value.id } }}>{displayText(value)}{row.can_edit_key ? '(暂不支持的店铺，如需支持请联系开发人员)' : ''}</bean-link>
          } else {
            return <span>/</span>
          }
        },
      },
      'user',
      'order_date',
      'pay_amount',
      type === 'show' && 'freight',
      'free_amount',
      'paid_amount',
      'amount',
      'out_amount',
      {
        key: 'receivable_amount',
        renderCell(h, { props: { value, scope: { row } } }) {
          return <span style={{ color: row.is_even ? 'black' : 'red' }}>{value}</span>
        }
      },
      {
        key: 'received_amount',
        renderCell(h, { props: { value, scope: { row } } }) {
          return <span style={{ color: row.is_even ? 'black' : 'red' }}>{value}</span>
        }
      },
      type === 'show' && 'shop_name',
      type === 'show' && 'shop_site',
      type === 'show' && 'l_id',
      type === 'show' && 'real_freight',
      type === 'show' && 'sent_at',
      type === 'show' && {
        key: 'items',
        renderCell: (h, { props: { value } }) => {
          return <bean-table height={null} value={value} columns={[{
            prop: 'i_id',
            label: '款号',
          }, {
            prop: 'name',
            label: '商品名称',
          }, {
            prop: 'pic',
            label: '图片',
            renderCell(h, { props: { value } }) {
              return <el-image style="width: 100px; height: 100px" src={value} fit="contain" preview-src-list={[value]}  />
            }
          }, {
            prop: 'price',
            label: '单价',
          }, {
            prop: 'qty',
            label: '数量',
          }, {
            prop: 'out_qty',
            label: '出库数量',
          }, {
            prop: 'amount',
            label: '总额',
          }, {
            prop: 'properties_value',
            label: '属性',
          }]} />
        },
      },
      type === 'show' && 'buyer_message',
      type === 'show' && 'remark',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'user_id'
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'jushuitan_orders.edit', params: { id: row.id } }
        }
      },
      false && row.can_edit_key && { // 聚水潭列表不再支持补录信息
        component: 'dialogFormButton',
        props: {
          label: '补录信息',
          value: row,
          columns: [
            {
              prop: 'key',
              label: '客户',
              renderCell: {
                component: 'select',
                hint: '注意：订单同步聚水潭数据后如包含关联客户信息 或 客户关联订单的关联类型或关联值有变更，则此次提交的内容将会失效',
                props: {
                  clearable: true,
                  xRemotePreload: async () => {
                    return (await this.$request.get('customer_jushuitan_order_relations/read_options', { per_page: 100 })).data.map(item => ({ value: item.jushuitan_order_key, label: displayText(item) }));
                  },
                  xRemoteSearch: async (keyword) => {
                    return (await this.$request.get('customer_jushuitan_order_relations/read_options', { keyword })).data.map(item => ({ value: item.jushuitan_order_key, label: displayText(item) }));
                  }
                },
                domProps: {
                  style: 'width: 100%'
                }
              }
            }
          ],
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/jushuitan_orders/${row.id}/update_key`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
      row.can_bind_customer && {
        component: 'dialogFormButton',
        props: {
          label: '关联客户',
          value: row,
          columns: [
            {
              prop: 'customer_id',
              label: '客户',
              renderCell: {
                component: 'select',
                hint: '注意：如果关联成功，则同类型订单也会关联到这个客户上',
                props: {
                  clearable: true,
                  xRemotePreload: async () => {
                    return (await this.$request.get('customers/read_options', { per_page: 100, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
                  },
                  xRemoteSearch: async (keyword) => {
                    return (await this.$request.get('customers/read_options', { keyword, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
                  }
                },
                domProps: {
                  style: 'width: 100%'
                }
              }
            }
          ],
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/jushuitan_orders/${row.id}/bind_customer`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
      row.can_unbind_customer && {
        component: 'confirmButton',
        props: {
          label: '解绑客户',
          title: '注意：解绑后同类型订单也会解除关联，确认解绑吗？',
          type: 'danger'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/jushuitan_orders/${row.id}/unbind_customer`));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
      abilityService.can('jushuitan_orders.update_user') && {
        component: 'dialogFormButton',
        props: {
          label: '关联业务员',
          columns: [
            {
              prop: 'user_id',
              label: this.$t('jushuitanOrder.user'),
              renderCell: {
                component: 'select',
                props: {
                  xRemotePreload: async () => {
                    return (await this.$request.get('users/read_options', { per_page: 100, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
                  },
                  xRemoteSearch: async (keyword) => {
                    return (await this.$request.get('users/read_options', { keyword, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
                  }
                }
              }
            }
          ],
          value: {},
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/jushuitan_orders/${row.id}/update_user`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      /* abilityService.can('jushuitan_orders.attach_payment') && !row.is_even && {
        component: 'dialogFormButton',
        props: {
          label: '关联收款',
          columns: paymentAllocationFormCloumnsExtend([
            {
              key: 'payment_id',
              renderCell: {
                props: {
                  xRemotePreload: async () => {
                    return (await this.$request.get('/payments/read_options', { customer_id_eq: row.customer_id, unallocated: true, per_page: 100 })).data.map(item => ({ value: item.id, label: displayText(item) }));
                  },
                  xRemoteSearch: async (keyword) => {
                    return (await this.$request.get('/payments/read_options', { keyword, customer_id_eq: row.customer_id, unallocated: true })).data.map(item => ({ value: item.id, label: displayText(item) }));
                  }
                }
              }
            },
            'amount',
          ], { data: {}, type: 'new' }),
          value: {},
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.post(`/jushuitan_orders/${row.id}/attach_payment`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }, */
      /* abilityService.can('adjustments.create') && !row.is_even && {
        component: 'dialogFormButton',
        props: {
          label: '调整应收',
          columns: adjustmentFormCloumnsExtend([
            'amount',
            'remark',
          ], { data: {}, type: 'new' }),
          value: {},
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.post('/adjustments', { ...value, adjustable_id: row.id }));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }, */
      row.can_receive_ignore && {
        component: 'confirmButton',
        props: {
          label: row.receive_ignored ? '取消忽略应收' : '忽略应收',
          type: 'danger',
          can: 'jushuitan_orders.receive_ignore'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/jushuitan_orders/${row.id}/receive_ignore`, { receive_ignored: !row.receive_ignored }));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    ].filter(Boolean);
  }

  get hasBatchActions() {
    return abilityService.can('jushuitan_orders.receive_ignore') || abilityService.can('jushuitan_orders.read');
  }

  batchActions({ selection }, { reload }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$autoLoading(this.$request.get('/jushuitan_orders/export', { ...this.$route.query }));
      } else {
        await this.$autoLoading(this.$request.get('/jushuitan_orders/export', { ...this.$route.query, id_in: _.map(selection, item => item.id) }));
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>,
      {
        component: 'button',
        props: {
          label: `批量忽略应收 (${selection.length})`,
          type: 'danger',
          can: [],
          disabled: selection.length === 0
        },
        on: {
          click: async () => {
            const ids = selection.map(item => item.id);
            await this.$confirm(`确定忽略应收 ${ids.length} 条订单?`)
            await this.$autoLoading(this.$request.put('/jushuitan_orders/batch_receive_ignore', { id_in: ids }))
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    ];
  }

  async downloadFreightTpl() {
    const result = await this.$request.get('/jushuitan_orders/import_freight_template', {}, { responseType: 'blob', return_res: true, timeout: 5 * 60 * 1000 })
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new Blob([result.data]);
    a.href = window.URL.createObjectURL(blob);
    a.download = '运费导入模板.xlsx';
    a.click();
    document.body.removeChild(a);
  }

  async upload(file) {
    const form = new FormData();
    form.append('file_message', file);
    const requestConfig = {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
      return_res: true,
      // 1小时超时
      timeout: 1 * 60 * 60 * 1000
    }
    const result = await this.$request.post('/jushuitan_orders/import_freight', form, requestConfig);
    if (result.headers['x-error-message']) {
      throw new Error(decodeURIComponent(result.headers['x-error-message']));
    }
    if (+result.headers['x-error-count'] > 0) {
      this.download(new Blob([result.data]), `${this.$t('bean.error_massage')}.xlsx`);
      throw new Error(this.$t('bean.importFail'));
    }
  }

  // 为了支持导入成功之后刷新页面
  async handleImportFreightFileChange(e) {
    const file = e.target.files[0];
    this.importing = true;
    let toastInstance = null;
    if (this.loadingToast) {
      toastInstance = this.$message.info({
        message: this.loadingToast,
        duration: 0,
        showClose: true
      });
    }
    try {
      await this.upload(file);
      this.$message.success(this.$t('bean.importSuccess'));
      window.location.reload();
    } catch (e) {
      const msg = e.message || this.$t('bean.importFail');
      this.$message.error(msg);
    } finally {
      this.importing = false;
      if (toastInstance) {
        toastInstance.close();
      }
    }
    e.target.value = '';
  }
}

export const route = [
  {
    path: '/jushuitan_orders',
    name: 'jushuitan_orders.index',
    component: JushuitanOrders,
    props: {
      type: 'index',
    }
  },
  {
    path: '/jushuitan_orders/new',
    name: 'jushuitan_orders.new',
    component: JushuitanOrders,
    props: {
      type: 'new',
    }
  },
  {
    path: '/jushuitan_orders/:id',
    name: 'jushuitan_orders.show',
    component: JushuitanOrders,
    props: {
      type: 'show',
    }
  },
  {
    path: '/jushuitan_orders/:id/edit',
    name: 'jushuitan_orders.edit',
    component: JushuitanOrders,
    props: {
      type: 'edit'
    }
  }
]
</script>
